function helperDefaultCompare (v1, v2) {
  return v1 === v2
}

module.exports = helperDefaultCompare



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/helperDefaultCompare.js
// module id = 416
// module chunks = 75